import React from "react";
import LoginPage from "./LoginPage";

const AdminLogin = () => {
  return <LoginPage userRole="ADMIN" />;
};

export default AdminLogin;
